<template>
    <div class="bg-white p-5 shadow-md rounded-xl h-full">
        <h2 class="text-lg font-semibold text-gray-700 mb-3 flex items-center">
            <span class="mr-2">🏢</span>
            <span>Partners by Entity</span>
        </h2>
        <div v-if="hasData" class="chart-container">
            <apexchart type="bar" height="260" :options="chartOptions" :series="chartSeries" @dataPointSelection="onBarSelect" />
        </div>
        <div v-else class="chart-empty">
            <span class="chart-empty-icon">📊</span>
            <p class="chart-empty-text">No data available</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PartnersByEntityChart",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    toolbar: { show: false },
                },
                xaxis: {
                    categories: this.data.map(item => this.formatEntityName(item.entity)),
                    title: {
                        text: 'Entity',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        },
                    },
                },
                yaxis: {
                    title: {
                        text: 'Number of Partners',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        },
                    },
                    min: 0,
                    forceNiceScale: true,
                },
                colors: this.getPowerBIColors(),
                plotOptions: {
                    bar: {
                        borderRadius: 8,
                        borderRadiusApplication: "end",
                        columnWidth: "55%",
                        distributed: true,
                        dataLabels: {
                            position: "center",
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    offsetY: 0,
                    style: {
                        fontSize: "13px",
                        fontWeight: 700,
                        colors: ["#ffffff"],
                    },
                    formatter: function (val) {
                        return val;
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " partner" + (val === 1 ? "" : "s");
                        },
                    },
                },
                legend: {
                    show: false
                },
                grid: {
                    borderColor: "#e2e8f0",
                    strokeDashArray: 4,
                },
            };
        },
        chartSeries() {
            return [
                {
                    name: "Partners",
                    data: this.data.map(item => item.count)
                }
            ];
        }
    },
    methods: {
        onBarSelect: function (event, chartContext, config) {
            var index = config && typeof config.dataPointIndex === "number" ? config.dataPointIndex : -1;
            var selectedItem = this.data && index >= 0 ? this.data[index] : null;
            if (selectedItem && selectedItem.entity) {
                this.onEntityBarClick(selectedItem.entity);
            }
        },
        onEntityBarClick(entity) {
            this.$emit('entity-clicked', entity);
        },
        formatEntityName(entity) {
            return entity.replace(/ATHS/g, "ATS");
        },
        getPowerBIColors() {
            // Power BI inspired color palette
            return [
                '#1f77b4', // Blue
                '#ff7f0e', // Orange
                '#2ca02c', // Green
                '#d62728', // Red
                '#9467bd', // Purple
                '#8c564b', // Brown
                '#e377c2', // Pink
                '#7f7f7f', // Gray
                '#bcbd22', // Olive
                '#17becf', // Cyan
                '#aec7e8', // Light Blue
                '#ffbb78', // Light Orange
                '#98df8a', // Light Green
                '#ff9896', // Light Red
                '#c5b0d5', // Light Purple
                '#c49c94', // Light Brown
                '#f7b6d3', // Light Pink
                '#c7c7c7', // Light Gray
                '#dbdb8d', // Light Olive
                '#9edae5'  // Light Cyan
            ];
        }
    }
};
</script>

<style scoped>
.chart-container {
    cursor: pointer;
}
.chart-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 350px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px dashed #cbd5e1;
}

.chart-empty-icon {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    opacity: 0.6;
}

.chart-empty-text {
    font-size: 0.9375rem;
    color: #64748b;
}
</style>
